import { ErrorHandler, Injectable } from '@angular/core';
import { pushErrorToFaro } from 'tofe-core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    // Log to console for immediate visibility
    console.error('[GlobalErrorHandler]', error);

    // Push error to Grafana Faro for RUM
    try {
      if (error instanceof Error) {
        pushErrorToFaro(error);
      } else if (typeof error === 'string') {
        pushErrorToFaro(new Error(error));
      } else {
        pushErrorToFaro(new Error(JSON.stringify(error)));
      }
    } catch (faroError) {
      // Silently fail - don't want observability to break the app
      console.warn('[GlobalErrorHandler] Failed to push error to Faro:', faroError);
    }

    // Rethrow the error if you want it to propagate further
    throw error;
  }
}

export const GlobalErrorHandlerProvider = {
  provide: ErrorHandler,
  useClass: GlobalErrorHandler,
};
